export default "__VITE_ASSET__C76hzvYp__"